<div class="flex-fill d-flex flex-row">
    <div class="d-flex flex-column" style="width: 70%">
        <div class="d-flex btn-toolbar justify-content-start mt-2 ms-3 mb-0">
            <button type="button" accesskey="s" (click)="saveEmailBody()" [disabled]="!uow.hasChanges()" class="btn btn-primary">Save</button>
            <button type="button" (click)="cancelEmailBody()" [disabled]="!uow.hasChanges()" class="btn btn-secondary ms-2">Cancel</button>
        </div>
        <div class="d-flex flex-row flex-fill pb-4">
            <div *ngIf="ready" class="d-flex flex-fill flex-column px-3">
                <div>
                    <div class="input-header">Genesis Office Email</div>
                    <dx-text-box [(value)]="genesisOffice.stringValue"></dx-text-box>
                </div>
                <div class="input-header">Default Invoice Email Body</div>
                <dx-text-area class="share-height" [(value)]="invoiceEmailBody.stringValue"></dx-text-area>
                <div class="input-header">Default Sales Order Email Body</div>
                <dx-text-area class="share-height" [(value)]="salesOrderEmailBody.stringValue"></dx-text-area>
                <div class="input-header">Default Purchase Order Email Body</div>
                <dx-text-area class="share-height" [(value)]="purchaseOrderEmailBody.stringValue"></dx-text-area>
            </div>
            <div *ngIf="ready" class="d-flex flex-fill flex-column pe-3">
                <div class="input-header">Default Warranty Email Body</div>
                <dx-text-area class="share-height" [(value)]="warrantyEmailBody.stringValue"></dx-text-area>
                <div class="input-header">Default Dealer Entry Email Body</div>
                <dx-text-area class="share-height" [(value)]="dealerEntryEmailBody.stringValue"></dx-text-area>
                <div class="input-header">Default Sales Order Confirmed Email Body</div>
                <dx-text-area class="share-height" [(value)]="salesOrderConfirmedEmailBody.stringValue"></dx-text-area>
            </div>
            <div *ngIf="ready" class="d-flex flex-fill flex-column pe-3">
                <div class="input-header">Default ACH Email Subject</div>
                <dx-text-box [(value)]="achEmailSubject.stringValue"></dx-text-box>
                <div class="input-header">Default ACH Entry Email Body</div>
                <dx-text-area class="share-height" [(value)]="achEmailBody.stringValue"></dx-text-area>
                <div class="input-header">Default ACH Portal Message 1</div>
                <dx-text-area class="share-height" [(value)]="achPortalMessage1.stringValue"></dx-text-area>
                <div class="input-header">Default ACH Portal Message 2</div>
                <dx-text-area class="share-height" [(value)]="achPortalMessage2.stringValue"></dx-text-area>
                <div class="input-header">Default ACH Portal Fee Message</div>
                <dx-text-area class="share-height" [(value)]="achPortalFeeMessage.stringValue"></dx-text-area>
            </div>
        </div>
    </div>

    <div class="d-flex flex-fill m-1" *ngIf="emails">
        <dx-data-grid
            class="grid-fill h-100"
            #dataGrid
            keyExpr="id"
            [dataSource]="emails"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onCellDblClick)="rowDoubleClick($event)"
            (onExporting)="onExporting($event)"
        >
            <dxi-column dataField="name" width="200" [sortIndex]="0" sortOrder="asc"></dxi-column>
            <dxi-column dataField="email" width="400"></dxi-column>
            <dxi-column width="200"></dxi-column>

            <dxo-remote-operations [sorting]="true" [paging]="true" [filtering]="true"></dxo-remote-operations>
            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button (click)="open(true)" class="btn btn-sm btn-secondary">New</button>
                <button
                    class="btn btn-sm btn-danger ms-2"
                    (click)="delete(dataGrid.instance.getSelectedRowsData())"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
                    [hidden]="!auth.hasRole('Administrator')"
                >
                    Delete
                </button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'"></div>
        </dx-data-grid>
    </div>
</div>
